import Vue from "vue";
import {
  Icon,
  Tab,
  Tabs,
  List,
  Cell,
  Button,
  Popup,
  Field,
  Dialog,
  Toast,
  Swipe,
  SwipeItem,
  Area,
  NavBar,
  CellGroup,
  Image,
  Sticky,
  Form,
  Picker,
  Popover,
  Sidebar,
  SidebarItem,
  Uploader,
  Tabbar,
  TabbarItem,
  Radio,
  RadioGroup,
  Step,
  Steps,
  DropdownMenu,
  DropdownItem,
  Search
} from "vant";

Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Area);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Image);
Vue.use(Sticky);
Vue.use(Form);
Vue.use(Picker);
Vue.use(Popover);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Uploader);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Step);
Vue.use(Steps);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
